import * as React from "react";
import { useMachine } from "@xstate/react";
import { Panel } from "@nju/ui";
import { changePasswordMachine } from "./changePassword.machine";
import { ChangePasswordError } from "./partials/ChangePasswordError";
import { ChangePasswordForm } from "./partials/ChangePasswordForm";
import { ChangePasswordSuccess } from "./partials/ChangePasswordSuccess";

export function DashboardUserProfileChangePasswordPage() {
  const [{ context, matches }, send] = useMachine(changePasswordMachine);

  const handleOldPasswordChange: React.ChangeEventHandler<HTMLInputElement> =
    React.useCallback(
      ({ target }) => {
        send({ type: "SET", name: "oldPassword", value: target.value });
      },
      [send],
    );

  const handleNewPasswordChange: React.ChangeEventHandler<HTMLInputElement> =
    React.useCallback(
      ({ target }) => {
        send({ type: "SET", name: "newPassword", value: target.value });
      },
      [send],
    );

  const handleRepeatNewPasswordChange: React.ChangeEventHandler<HTMLInputElement> =
    React.useCallback(
      ({ target }) => {
        send({ type: "SET", name: "repeatNewPassword", value: target.value });
      },
      [send],
    );

  const handleSubmit: React.FormEventHandler<HTMLFormElement> =
    React.useCallback(
      (event) => {
        event.preventDefault();
        send({ type: "SEND" });
      },
      [send],
    );

  if (matches("success")) {
    return <ChangePasswordSuccess />;
  }

  if (matches("error")) {
    return <ChangePasswordError />;
  }

  return (
    <Panel>
      <ChangePasswordForm
        context={context}
        handleNewPasswordChange={handleNewPasswordChange}
        handleOldPasswordChange={handleOldPasswordChange}
        handleRepeatNewPasswordChange={handleRepeatNewPasswordChange}
        handleSubmit={handleSubmit}
        isLoading={matches("submit")}
      />
    </Panel>
  );
}
